import type { ComponentStyleConfig } from '@chakra-ui/react';

import * as variants from '../typography';

const TextComponentStyle: ComponentStyleConfig = {
  variants: {
    ...variants,
  },
  defaultProps: {
    variant: 'paragraph',
  },
};

export default TextComponentStyle;
